import * as React from 'react'
import { useState } from 'react'
import { ActionButton, DialogFooter, IDialogProps, Label, PrimaryButton, Stack, StackItem, Text, TextField } from '@fluentui/react'
import LegacyBaseDialog from '../LegacyBaseDialog'
import { formatInputDocumentName, formatInputFolderName } from '../../../helpers/regexHelper'
import useAxios from '../../../hooks/useAxios'
import { Destination } from '../../../context/AxiosContext'
import { IDocumentStackItemDto, IFolderOverviewItemDto } from '../../../config/documentConfig'
import { useTranslation } from 'react-i18next'

type Props = IDialogProps & {
    isRoot: boolean
    parent: IFolderOverviewItemDto
    reset: (stack?: IDocumentStackItemDto[]) => void
}

export default function CreateFolderDialog(props: Props) {
    const axios = useAxios()
    const { t: translate } = useTranslation()

    const [name, setName] = useState<string>('')
    const title = translate(props.isRoot ? 'file.pivot.document.create.folder.root' : 'file.pivot.document.create.folder.sub')

    return (
        <LegacyBaseDialog dialogContentProps={{ title }} {...props}>
            <Stack tokens={{ childrenGap: 's1' }}>
                {!props.isRoot && (
                    <StackItem>
                        <Label>{translate('file.pivot.document.create.folder.parent')}</Label>
                        <Text>{props.parent.name}</Text>
                    </StackItem>
                )}
                <StackItem>
                    <TextField
                        autoFocus
                        label={translate('file.pivot.document.create.folder.name')}
                        value={name}
                        onChange={(_, value?: string) => setName(formatInputDocumentName(value))}
                    />
                </StackItem>
            </Stack>
            <DialogFooter>
                <PrimaryButton
                    text={translate('file.pivot.document.create.folder.submit')}
                    disabled={!name}
                    onClick={() =>
                        // Folder names may not end in a dot (SharePoint rejects those). Stripping while
                        // typing would make it impossible to enter dots at all, so only strip on submit.
                        axios
                            .post(
                                `/items/${props.parent.id}/children`,
                                { folder: {}, name: formatInputFolderName(name) },
                                { baseURL: Destination.Documents },
                            )
                            .then(() => {
                                props.onDismiss()
                                props.reset([...props.parent.stack, { id: props.parent.id, name: props.parent.name }])
                            })
                    }
                />
                <ActionButton text={translate('action.cancel')} onClick={props.onDismiss} />
            </DialogFooter>
        </LegacyBaseDialog>
    )
}
